import { DEFAULT_PROJECT_STATE } from '@/components/Projects/CreateProjectModal/constants';
import {
  Project,
  ProjectCreate,
  CompanyResource,
  ManagerCreate,
  AddressInput,
  ActivityInput,
} from '@/graphql/generated/graphql';
import { createContext } from 'react';
import { defaultCompanySettingsType } from './Provider';

export type ManagerOption = {
  id: string;
  name?: string | null;
  email?: string | null;
  user?: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    imageUrl?: string | null;
  } | null;
};

interface ProjectContextValueType {
  mode: string; // create | edit
  parentProject: Project | undefined;
  project: ProjectCreate;
  setProject: React.Dispatch<React.SetStateAction<ProjectCreate>>;
  loadingProject: boolean;
  managers: (CompanyResource | ManagerOption)[];
  isProjectCodeUnique: (code: string) => boolean;
  isSaving: boolean;
  lastSaved: Date | null;
  handleCreateProject: (options?: { silent?: boolean; onSuccess?: () => void }) => void;
  onProjectDataChange: (key: string, value: string | ManagerCreate[]) => void;
  onAddressesChange: (addresses: AddressInput[]) => void;
  onTagsChange: (selectedTags: string[]) => void;
  onContractChange: (contractIds: string[]) => void;
  onActivitiesChange: (activities: ActivityInput[]) => void;
  onSettingsChange: (newSettings: { name: string; value: string }[]) => void;
  onClientRepChange: (index: number, field: string, value: string) => void;
  onClientRepRemove: (index: number) => void;
  onAddClientRep: () => void;
  onManagerTitleChange: (manager: ManagerCreate, title: string) => void;
  getManagerData: (companyResourceId?: string | null) => CompanyResource | ManagerOption;
  handleResetProject: (onDone?: () => void) => void;
  resetKey: number;
  defaultCompanySettings: defaultCompanySettingsType;
}

export const ProjectContext = createContext<ProjectContextValueType>({
  mode: 'create',
  parentProject: undefined,
  project: { ...DEFAULT_PROJECT_STATE },
  setProject: () => {},
  loadingProject: false,
  managers: [],
  isProjectCodeUnique: () => true,
  isSaving: false,
  lastSaved: null,
  handleCreateProject: () => {},
  onProjectDataChange: () => {},
  onAddressesChange: () => {},
  onTagsChange: () => {},
  onContractChange: () => {},
  onActivitiesChange: () => {},
  onSettingsChange: () => {},
  onClientRepChange: () => {},
  onManagerTitleChange: () => {},
  getManagerData: () => ({}) as CompanyResource,
  onClientRepRemove: () => {},
  onAddClientRep: () => {},
  handleResetProject: () => {},
  resetKey: 0,
  defaultCompanySettings: {} as defaultCompanySettingsType,
});
